import React from 'react';
import {Card, Tooltip} from "antd";
import CardHeadExtra from "./CardHeadExtra";
import {getCardHeadPath} from "../PublicMethodTsx";
import '../../css/cardPreview.css';

interface CardData{
    items:any,
    cardPreview:any,
}
const CardHeadAddModule: React.FC<CardData> = (cardData) => {
    return (
        <>
            <Card
                hoverable={false}
                className="card-extend"
                style={{background:"var(--cardPreviewBackgroundColor)"}}
                headStyle={{background:"#ffe100",borderRadius:"6px 6px 0px 0px",minHeight:"43px",height:"43px"}}
                bodyStyle={{height:"100%",padding:"16px 8px"}}
                title={
                    <div className={"head-card-title"}>
                        <div className={"head-card-title-label"}>
                            <div style={{lineHeight:"19px",marginTop:"-1px"}}>{cardData.items.viewDispName}</div>
                        </div>
                        <div style={{flex:"1",textAlign:"left",marginLeft:"2px"}}>
                            <Tooltip title={cardData.items.pathAbbr} color="#C9CACA" overlayInnerStyle={{color:"#282829",marginTop:"-8px",width:"100%"}} placement="bottom">
                                <div style={{fontSize:"11px"}}>{getCardHeadPath(cardData.items.pathAbbr,"11")}</div>
                            </Tooltip>
                        </div>
                    </div>
                }
                type="inner"
            >
                <cardData.cardPreview viewOperate={null} viewTypeList={null} setViewTypeList={null} param={{...cardData.items, mechId: cardData.items.motionId}}
                                      realData={[cardData.items]} setActiveKey={null} setItems={null} items={cardData.items}/>
            </Card>
        </>

    );
};
export default CardHeadAddModule;